import type {MaskingItemObject} from '@PosterWhiteboard/classes/item-masking.class';
import type {MaskingTextObject} from '@PosterWhiteboard/classes/masking/masking-text.class';
import type {MaskOptsInterface} from '@Libraries/mask';

export interface PointMaskProps {
  id: string;
  url: string;
  opts: MaskOptsInterface;
}

export interface ShapeBackendData {
  idPMWStockShape: number;
  isMask: boolean;
  isHidden: boolean;
  keywords: Array<string>;
  sortOrder: number;
  type: string;
}

export interface EditRowListToggles {
  icon: string;
  callback: () => void;
  isEnabled: boolean;
}

export interface ShapeMaskProps {
  id: string;
  url: string;
  opts: ShapeMaskOptions;
}

export interface ShapeMaskOptions {
  existingMaskingItem?: MaskingItemObject;
}

export interface TextMaskProps {
  id: string;
  url: string;
  opts: TextMaskOptions;
}

export interface TextMaskOptions {
  existingMaskingItem?: MaskingTextObject;
}

export enum PANEL_TYPES {
  FREEHAND = 'Freehand',
  SHAPE = 'Shape',
  TEXT = 'Text',
}
